import { render } from "./Topbar.vue?vue&type=template&id=73dc252c"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
script.render = render

export default script